'use client';

import { SwdFormControlLabel } from '@/components/swdFormControlLabel/SwdFormControlLabel';
import { SwdFormGroup } from '@/components/swdFormGroup/SwdFormGroup';
import { SwdSwitch } from '@/components/swdSwitch/SwdSwitch';
import { useEffect, useState } from 'react';

import styles from './MapLayerControl.module.scss';

export class MapLayerController {
  readonly id: string;
  readonly label: string;

  constructor(
    id: string,
    label: string,
    private map: any,
    private layer: any
  ) {
    this.id = id;
    this.label = label;
    this.layer.setMap(map);
  }

  switchOn() {
    this.layer.setMap(this.map);
  }

  switchOff() {
    this.layer.setMap(null);
  }
}

export interface MapLayerControlProps {
  items: MapLayerController[];
}

const MapLayerControlItem: React.FC<{ controller: MapLayerController }> = ({ controller }) => {
  const [state, setState] = useState(true);

  useEffect(() => {
    state ? controller.switchOn() : controller.switchOff();
  }, [controller, state]);

  const control = (
    <SwdSwitch
      checked={state}
      onChange={(e) => {
        setState(e.target.checked);
      }}
    />
  );

  return <SwdFormControlLabel control={control} label={controller.label} />;
};

const MapLayerControl: React.FC<MapLayerControlProps> = ({ items }) => {
  return (
    <SwdFormGroup>
      <div className={styles.MapLayerControl}>
        {items.map((item) => (
          <MapLayerControlItem key={item.id} controller={item} />
        ))}
      </div>
    </SwdFormGroup>
  );
};

export default MapLayerControl;
